import { SxProps, Theme } from "@mui/material/styles";

export const getGoBadgeStyles = (
    textColor: string,
    backgroundColor: string,
    borderColor: string
): SxProps<Theme> => ({
    color: textColor,
    backgroundColor: backgroundColor,
    border: `2px solid ${borderColor}`,
    padding: "4px 6px",
    borderRadius: "2px",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "13px",
    display: "inline-flex",
    alignItems: "center",
    whiteSpace: "nowrap"
});
